import { ISelectCustomersHook } from '@models';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

export const useSelectCustomers = (): ISelectCustomersHook => {
  const { customerStore } = useStore();
  const { selectCustomers, selectLoading, selectSkipCount, selectPageSize } = customerStore;
  const [keyword, setKeyword] = useState<string>();

  useEffect(() => {
    keyword &&
      customerStore.getSelectCustomers({
        keyword,
        maxResultCount: selectPageSize,
        skipCount: selectSkipCount,
      });

    return () => customerStore.clearSelectCustomers();
  }, [customerStore, keyword, selectSkipCount, selectPageSize]);

  // One debounce for the life of the box: made in the body it was a new one on every render, and
  // every keystroke re-renders, so none of them ever swallowed another and "abcd" searched for
  // "a", "ab", "abc" and "abcd" in turn.
  const handleSearch = useMemo(
    () => debounce((text: string | undefined) => setKeyword(text?.trim()), 300),
    []
  );
  useEffect(() => () => handleSearch.cancel(), [handleSearch]);

  return {
    customers: Array.from(selectCustomers.values()),
    loading: selectLoading,
    handleSearch,
  };
};
